var map = {
	"./Academic.svg": 3077,
	"./Arts and Music.svg": 9768,
	"./Charity and Fundraising.svg": 1735,
	"./Crafts and Hobbies.svg": 702,
	"./Environment and Nature.svg": 9762,
	"./Faith.svg": 9497,
	"./Fiction and Fantasy.svg": 5447,
	"./Food and Drink.svg": 5815,
	"./Health and Wellbeing.svg": 1169,
	"./Languages and Culture.svg": 1947,
	"./Media and Broadcasting.svg": 3707,
	"./Other.svg": 4178,
	"./Political and Activism.svg": 480,
	"./Skills and Employability.svg": 3151,
	"./Sport.svg": 2297,
	"./Technology and Gaming.svg": 5615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606;